// On phones a long timeline shows its first steps and fades out under "Show more".
const phone = window.matchMedia('(max-width: 640px)');

function bind(root: HTMLElement): void {
	const list = root.querySelector<HTMLElement>('.armada-process__list');
	const button = root.querySelector<HTMLButtonElement>('.armada-process__more');
	const visible = Number(root.dataset.armadaSteps);

	if (!list || !button || !visible) {
		return;
	}

	const steps = Array.from(list.children) as HTMLElement[];

	const fold = (): void => {
		if (root.classList.contains('is-open') || !phone.matches || steps.length <= visible) {
			root.classList.remove('is-folded');
			button.hidden = true;
			return;
		}

		// Everything up to the first hidden step, plus a peek of it behind the fade.
		const next = steps[visible];
		// A page can let more show through with --process-fold.
		const cap = parseFloat(getComputedStyle(root).getPropertyValue('--process-fold')) || 230;
		const folded = Math.min(next.offsetTop + 100, cap);
		root.style.setProperty('--folded', `${folded}px`);
		root.classList.add('is-folded');
		button.hidden = false;
	};

	button.addEventListener('click', () => {
		root.style.setProperty('--folded', `${list.scrollHeight}px`);
		root.classList.add('is-open');
		button.hidden = true;

		list.addEventListener(
			'transitionend',
			() => {
				root.classList.remove('is-folded');
			},
			{ once: true }
		);
	});

	fold();
	phone.addEventListener('change', fold);
	window.addEventListener('resize', fold, { passive: true });
}

export default function initProcess(): void {
	document.querySelectorAll<HTMLElement>('[data-armada-steps]').forEach(bind);
}
